<template>
    <v-container class="fill-height" fluid>
        <v-row align="center" justify-content="center" style="justify-content: center;">
            <v-col cols="12" sm="8" md="4">
                <v-card class="elevation-12" color="grey lighten-4">
                    <v-card-text>
                        <v-form>
                            <v-text-field
                                label="Email"
                                id="email"
                                name="login"
                                type="text"
                                :rules="[
                                    v =>
                                        !v ||
                                        /^\w+([.+-]?\w+)*@\w+([.+-]?\w+)*(\.)\w+$/.test(v) ||
                                        this.t('E-mail must be valid')
                                ]"
                                v-model="email"
                            />

                            <v-text-field
                                id="password"
                                :label="this.t('Password')"
                                name="password"
                                type="password"
                                v-model="password"
                            />
                        </v-form>
                        <v-alert v-model="error" type="error" color="bal-red">
                            {{ "Wrong email or password" | t }}
                        </v-alert>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer />
                        <v-btn id="loginClick" @click="handleLoginClick">{{ "Login" | t }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-snackbar color="error" v-model="user.error" bottom right :timeout="2500" value="ERROR">
            <div style="display: flex">
                <v-icon color="#FFF">error</v-icon>
                <div class="title pa-2" v-if="user.is_blocked">{{ "Too many login attempts. Your account is temporarily locked for 15 minutes. Please try again later. Thanks for your patience." | t }}</div>
                <div class="title pa-2" v-else>{{ "Something went wrong. Please try again" | t }}</div>
            </div>
        </v-snackbar>
    </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import settings from "@/settings";
export default {
    name: "login",
    data() {
        return {
            email: null,
            password: null,
            error: null
        };
    },
    async mounted() {
        const response = await axios.get(settings.app_url + "/login/?without-status=true");
        if (response && response.data && response.data.success === 1){
            return await this.$router.push({ name: "Dashboard" });
        } else {
            document.addEventListener("keydown", this.handleKeyboardListener);
        }

    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    computed: {
        ...mapState(["user"])
    },
    methods: {
        ...mapActions(["login"]),
        handleLoginClick() {
            let payload = {
                email: this.email,
                password: this.password
            };
            this.login(payload);
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 13) {
                this.handleLoginClick();
            }
        }
    }
};
</script>
